<template>
  <div id="data-list-list-view" class="data-list-container">
    <add-new-data-sidebar
      :isSidebarActive="showSidebar"
      @closeSidebar="toggleSideBar()"
      :title="titleSidebar"
    >
      <formCampanha
        @closeSideBar="toggleSideBar"
        :idCampanha.sync="idCampanhaSelected"
      ></formCampanha>
    </add-new-data-sidebar>

    <vs-table
      noDataText="Nenhum Cupom Encontrado"
      class="tablePrincipal"
      ref="table"
      multiple
      v-model="selected"
      pagination
      :max-items="itemsPerPage"
      search
      :data="itens"
    >
      <div
        slot="header"
        class="flex flex-wrap-reverse items-center flex-grow justify-between"
      >
        <div class="flex flex-wrap-reverse items-center">
          <!-- Ações Dropdown -->
          <ActionDropdown
            :selected="selected"
            nameFileXls="Campanha_Cupom"
            inativar
            @eventInativar="inativar(true)"
            reativar
            @eventReativar="inativar(false)"
            :subjectPermission="subjectPermission"
          />

          <!-- Nova Campanha/Cupom -->
          <ActionButtonNew 
            @toggleSideBar="newRecord()"
            :subjectPermission="subjectPermission"
          >
            Adicionar novo Campanha/Cupom
          </ActionButtonNew>
        </div>

        <!-- Seleção das Páginas -->
        <SelectPagination
          :currentPage="currentPage"
          :itemsPerPage="itemsPerPage"
          :length="itens.length"
          @update="itemsPerPage = $event"
        />
      </div>

      <template slot="thead">
        <vs-th>Tipo</vs-th>
        <vs-th>Cupom</vs-th>
        <vs-th>Início</vs-th>
        <vs-th>Final</vs-th>
        <vs-th>Desconto</vs-th>
        <vs-th>Status</vs-th>
        <vs-th>Ações</vs-th>
      </template>

      <template slot-scope="{ data }">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <!-- Tipo -->
            <vs-td>
              {{ tr.TipoCampanha.tipoCampanha }}
            </vs-td>

            <!-- Cupom -->
            <vs-td>
              <p class="product-category">{{ tr.cupom }}</p>
            </vs-td>

            <!-- Início -->
            <vs-td>
              {{ tr.dataInicio | formatDate }}
            </vs-td>

            <!-- Final -->
            <vs-td>
              {{ tr.dataFinal | formatDate }}
            </vs-td>

            <!-- Tipo Desconto -->
            <vs-td>
              {{ tr.ConvivenciaDesconto.tipoConvivencia }}
            </vs-td>

            <!-- Status -->
            <vs-td>
              <ChipStatus :value="tr.status"></ChipStatus>
            </vs-td>

            <vs-td>
              <ActionButtons
                view
                @viewClick="openModal(tr)"
                edit
                @editClick="edit(tr)"
                :subjectPermission="subjectPermission"
              ></ActionButtons>
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>

    <ModalInfo
      :modalSelecionado="arrayDataModal"
      :popupActive="showModalDetails"
      title="Dados da Campanha"
      @close="showModalDetails = false"
    ></ModalInfo>
  </div>
</template>

<script>
//#region Import's

import ActionButtonNew from "./../../utils/list/header/ActionButtonNew";
import ActionButtons from "../../utils/list/ActionButtons";
import ActionDropdown from "./../../utils/list/header/ActionDropdown";
import AddNewDataSidebar from "./../Includes/SideBar";
import ChipStatus from "../../utils/list/ChipStatus";
import ModalInfo from "../../components/ModalInfo";
import SelectPagination from "../../utils/list/header/SelectPagination.vue";
import UtilsList from "./../../utils/list/index";
import dateConversion from "./../../utils/dateConversion";
import formCampanha from "./../forms/FormCampanha";
import notify from "./../../utils/notify";
import processingListProdutos from "./../forms/FormCampanhaAux";
import service from "../../services";

//#endregion

export default {
  data() {
    return {
      showSidebar: false,
      selected: [],
      itemsPerPage: 10,
      itens: [],
      isMounted: false,
      dados: {},
      idCampanhaSelected: null,
      showModalDetails: false,
      arrayDataModal: [],
      editMode: false,
    };
  },
  props: ["subjectPermission"],
  computed: {
    titleSidebar() {
      return `${this.editMode ? "Editar" : "Adicionar"}  Campanhas`;
    },
    currentPage() {
      if (this.isMounted) {
        return this.$refs.table.currentx;
      }
      return 0;
    },
  },
  methods: {
    toggleSideBar() {
      this.showSidebar = !this.showSidebar;
      if (!this.showSidebar) {
        this.buscaDados();
      }
    },
    toogleModalDetails() {
      this.showModalDetails = !this.showModalDetails;
    },
    async buscaDados() {
      try {
        this.selected = [];
        this.$vs.loading();

        const action = `list/idEmpresa=${this.idEmpresa}`;
        const getAll = await service.getAll("Campanha", {}, action);

        if (Array.isArray(getAll.data)) {
          this.itens = getAll.data;
        }
      } catch (error) {
        notify.notifyFail(this.$vs, error);
      } finally {
        this.$vs.loading.close();
      }
    },
    edit(value) {
      this.idCampanhaSelected = value.idCampanha;
      this.editMode = true;
      this.toggleSideBar();
    },
    newRecord() {
      this.editMode = false;
      this.toggleSideBar();
    },
    async inativar(value) {
      const action = value ? "inativar" : "reativar";
      const result = await UtilsList.inativarRegistros(
        this.$vs,
        this.selected,
        "idCampanha",
        "Campanha",
        action
      );
      if (result) {
        this.buscaDados();
      }
    },
    async openModal(value) {
      try {
        this.$vs.loading();

        this.arrayDataModal = [
          {
            coluna: "Tipo",
            Tipo: value.TipoCampanha.tipoCampanha,
          },
          {
            coluna: "Cupom",
            Cupom: value.cupom,
          },
          {
            coluna: "Data Início",
            ["Data Início"]: dateConversion.converteISOToDate(value.dataInicio),
          },
          {
            coluna: "Data Final",
            ["Data Final"]: dateConversion.converteISOToDate(value.dataFinal),
          },
          {
            coluna: "Desconto",
            Desconto: value.ConvivenciaDesconto.tipoConvivencia,
          },
          {
            coluna: "Status",
            Status: value.status ? "Ativo" : "Inativo",
          },
        ];

        const listProdutos = await service.getAll(
          "Campanha",
          null,
          `getlistProdutos/${value.idCampanha}`
        );

        const arrayDescontoProdutos = processingListProdutos(listProdutos.data);
        const arrayDescontoProdutosDetails = [];

        arrayDescontoProdutos.forEach((element) => {
          arrayDescontoProdutosDetails.push({
            ["Produto"]: element.nomeProduto,
            [`Desconto`]: `(${element.prefixo}) ${element.valorMasked}`,
          });
        });

        this.arrayDataModal.push({
          coluna: "Lista de Produtos",
          ["Lista de Produtos"]: arrayDescontoProdutosDetails,
        });

        this.toogleModalDetails();
      } catch (error) {
        notify.notifyFail(this.$vs, error);
      } finally {
        this.$vs.loading.close();
      }
    },
  },
  created() {
    this.buscaDados();
  },
  mounted() {
    this.isMounted = true;
  },
  components: {
    ActionButtonNew,
    ActionButtons,
    ActionDropdown,
    AddNewDataSidebar,
    ChipStatus,
    ModalInfo,
    SelectPagination,
    formCampanha,
  },
};
</script>

<style lang="scss">
</style>